var animateText = {
    init: function () {
        Splitting({
            whitespace: true,
        });
    },
};

export { animateText };
